// extracted by mini-css-extract-plugin
module.exports = {"Loader":"Spinner_Loader__YbtYy","load2":"Spinner_load2__3mxmI"};